export default __webpack_public_path__ + "static/media/3.e500f040.png";